import React, { Component } from 'react'
import classNames from "classnames";

// core components
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import unitSelectorStylye from "assets/jss/prehnit/components/unitSelectorStyle.jsx";

import { withNamespaces } from "react-i18next";

import { units } from "config/UnitsConfig.jsx"
import { Context } from "Context.jsx";

class UnitSelector extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: false
        }

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSelectUnit = this.handleSelectUnit.bind(this);
    }

    handleClick = () => {
        this.setState(state => ({ open: !state.open }));
    };

    handleSelectUnit(unit, setUnit) {
        if (unit) {
            setUnit(unit);
            this.setState({
                open: false
            })
        }
    }

    handleClose = event => {
        if (this.anchorEl.contains(event.target)) {
          return;
        }

        this.setState({ open: false });
    };

    // handleCloseMenu(param) {
    //     this.setState({ open: false });
    //     if (this.props && this.props.onClick) {
    //       this.props.onClick(param);
    //     }
    // }

    render() {
        const { open } = this.state;
        const {
            t,
            classes,
            buttonText,
            buttonIcon,
            buttonProps,
            dropup,
            caret,
            hoverColor,
            dropPlacement,
            noLiPadding,
            innerDropDown,
            navDropdown
          } = this.props;

        const caretClasses = classNames({
            [classes.caret]: true,
            [classes.caretDropup]: dropup && !open,
            [classes.caretActive]: open && !dropup
        });

        const dropdownItem = classNames({
            [classes.dropdownItem]: true,
            [classes[hoverColor + "Hover"]]: true,
            [classes.noLiPadding]: noLiPadding && false,
          });

          const dropDownMenu = (
            <Context.Consumer>
                {({unit, setUnit}) => (
                    <MenuList role="menu" className={classes.menuList}>
                        { Object.values(units).map((prop, key) => {
                            return (


                                    <MenuItem
                                    key={key}
                                    onClick={() => this.handleSelectUnit(prop, setUnit)}
                                    className={dropdownItem}
                                >
                                    <Icon className={classes.dropdownIcons}>insert_chart_outlined</Icon>
                                    {t(prop.displayCode)}
                                </MenuItem>
                            );
                        })}
                        </MenuList>

                )}

            </Context.Consumer>

          );

        return (
            <div className={innerDropDown ? classes.innerManager : classes.manager}>
                <div className={buttonText !== undefined ? "" : classes.target}>
                <Button
                    aria-label="Notifications"
                    aria-owns={open ? "menu-list" : null}
                    aria-haspopup="true"
                    buttonRef={node => {
                    this.anchorEl = node;
                    }}
                    {...buttonProps}
                    onClick={this.handleClick}
                >
                    {buttonIcon !== undefined ? (
                    <this.props.buttonIcon className={classes.buttonIcon} />
                    ) : null}

                    <Context.Consumer>
                        {ctx => ctx.unit.short}
                    </Context.Consumer>
                    {caret ? <b className={caretClasses} /> : null}
                </Button>
                </div>
                <Popper
                open={open}
                anchorEl={this.anchorEl}
                transition
                disablePortal
                placement={dropPlacement}
                className={classNames({
                    [classes.popperClose]: !open,
                    [classes.pooperResponsive]: true,
                    [classes.pooperNav]: open && navDropdown
                })}
                >
                {({ TransitionProps, placement }) => (
                    <Grow
                    in={open}
                    id="menu-list"
                    style={
                        dropup
                        ? { transformOrigin: "0 100% 0" }
                        : { transformOrigin: "0 0 0" }
                    }
                    >
                    <Paper className={classes.dropdown}>
                        {innerDropDown ? (
                        dropDownMenu
                        ) : (
                        <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
                            {dropDownMenu}
                        </ClickAwayListener>
                        )}
                    </Paper>
                    </Grow>
                )}
                </Popper>
            </div>
        );
    }
}

UnitSelector.contextType = Context;

UnitSelector.defaultProps = {
    caret: true,
    buttonText: "---",
}

export default withNamespaces()(withStyles(unitSelectorStylye)(UnitSelector));